import { Routes, Route, Navigate } from "react-router-dom";
import { useAuthStore } from "./store/authStore";
import { AppLayout } from "./components/layout/AppLayout";
import { HomeView } from "./features/HomeView";
import { DMView } from "./features/dm/DMView";
import { GroupView } from "./features/groups/GroupView";
import { ChannelView } from "./features/servers/ChannelView";
import { LoginPage, RegisterPage } from "./features/auth/AuthPages";
import { AdminLayout } from "./features/admin/AdminLayout";

function AuthenticatedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  if (isAuthenticated) {
    return <Navigate to="/app/dm" replace />;
  }
  return <>{children}</>;
}

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/app" replace />} />
      <Route path="/login" element={<AuthenticatedRoute><LoginPage /></AuthenticatedRoute>} />
      <Route path="/register" element={<AuthenticatedRoute><RegisterPage /></AuthenticatedRoute>} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminLayout />} />
        <Route path="users" element={<AdminLayout />} />
        <Route path="servers" element={<AdminLayout />} />
        <Route path="emojis" element={<AdminLayout />} />
        <Route path="announce" element={<AdminLayout />} />
      </Route>
      <Route path="/app" element={<AppLayout />}>
        <Route index element={<HomeView />} />
        <Route path="dm" element={<DMView />} />
        <Route path="dm/:userId" element={<DMView />} />
        <Route path="group/:groupId" element={<GroupView />} />
        <Route path="server/:serverId/channel/:channelId" element={<ChannelView />} />
      </Route>
    </Routes>
  );
}
